import React, { Component } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {SingleDatePicker} from 'react-dates';
import TextEditor from '../../../../../Utilities/TextEditor/texteditor';
import { convertFromRaw } from 'draft-js';
import InnerSecondModal from './innerModals/InnerSecondModal';
import InnerFinalModal from './innerModals/innerFinalModal';
import {NotificationManager} from 'react-notifications';
import {stripUnicodeFromString} from '../../../../../Utilities/HelperFunctions/helper'
import {ContentState, EditorState, convertToRaw} from 'draft-js'

import * as ActionCreator from '../../../../../store/index';

import './modal.css';
import {connect} from 'react-redux';
import moment from 'moment';

const customEmailMessages = {
    messages: {
        searchPlaceholder: "Etsi sähköpostiosoitetta...",
        noItemsMessage: "Valitse sähköpostiosoite",
        noneSelectedMessage: "Valintoja ei ole",
        selectedMessage: "valittuna",
        selectAllMessage: "Valitse kaikki",
        clearAllMessage: "Tyhjennä valinnat",
        disabledItemsTooltip: "You can only select 1 file"
    }
};

const emptyBlock = () => {
    let contentState = ''
    contentState = ContentState.createFromText("")

    let editorState = EditorState.createWithContent(contentState);
    return convertToRaw(editorState.getCurrentContent())
}

class TaskCreatorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            taskType: "Tehtävä",
            innerSecond: false,
            innerFinal: false,
            emailList: [],
            selectedEmails: [],
            closeAll: false,
            selectedRiskLevel: null,
            emailToAdd: "",
            status: {},
            taskTitle: "",
            taskExplanation: emptyBlock(),
            deadline: null,
            notificationDate: null,
            focusedDeadline: false,
            focusedNotification: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.targetCompany !== this.props.targetCompany) {
            if(this.props.targetCompany.emailList !== undefined) {
                this.setState({
                    emailList: this.props.targetCompany.emailList
                });
            } else {
                this.setState({
                    emailList: []
                });
            }
        }

        if(prevProps.modal !== this.props.modal) {
            this.setState({modal: this.props.modal});

            if(this.props.modal) {
                this.props.onModalOpen({yTunnus: this.props.activeCompany.businessID, type: 'taskModal'});
            }
        }

        if(prevState.modal && !this.state.modal) {
            this.props.endAdd();
        }

        if(prevProps.chosenTarget.targetText !== this.props.chosenTarget.targetText) {
            this.setState({
                selectedEmails: [],
                emailToAdd: "",
                status: {},
                taskTitle: "",
                taskExplanation: emptyBlock(),
                deadline: null,
                notificationDate: null,
                selectedRiskLevel: null
            })
        }

        if(prevProps.fetchStatus !== this.props.fetchStatus && this.props.fetchMessage === "finished") {
            this.toggleAll();
            this.setState({
                selectedEmails: [],
                emailToAdd: "",
                status: {},
                taskTitle: "",
                taskExplanation: emptyBlock(),
                deadline: null,
                notificationDate: null,
                selectedRiskLevel: null
            })
        }
    }

    handleEmailChange = email => {
        let check = this.validateEmail(email.target.value)
        if(check.status) {
            this.setState({emailReady: true, emailToAdd: email.target.value, status: check});
        } else {
            this.setState({emailReady: false, emailToAdd: email.target.value, status: check});
        } 
    }

    handleEmailAdd = event => {
        if(event.key === 'Enter') {
            if(this.state.emailReady) {
                let emailObject = {
                    id: this.state.emailToAdd,
                    label: this.state.emailToAdd
                };

                let emails = [
                    ...this.state.emailList,
                    emailObject
                ];

                this.setState({emailList: emails, emailToAdd: "", startAddingEmail: false});
            }
        }
    }

    validateEmail = (email) => {
        let emailObject = {
            id: email,
            label: email
        };

        var regex = /[^@]+@[^\.]+\..+/; /*/^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;*/
        /* 	    
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/*/
        if(regex.test(email)) {
            if(this.state.emailList.filter(email => email.label === emailObject.label).length === 0) {
                return {
                    status: true,
                    feedback: "Lisää sähköposti painamalla 'Enter'-näppäintä"
                }
            } else {
                return {
                    status: false,
                    feedback: "Sähköposti on jo listalla"
                };
            }
        } else {
            return {
                status: false,
                feedback: "Syötä sähköpostiosoite oikeassa muodossa"
            }
        }
    }

    changeType = type => {
        this.setState({taskType: type.type});
    }

    toggle = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    toggleSecond = () => {
        this.setState({
          innerSecond: !this.state.innerSecond,
          modal: !this.state.modal,
          closeAll: false
        });
    }

    toggleFinal = () => {
        this.setState({
            innerSecond: !this.state.innerSecond,
            innerFinal: !this.state.innerFinal,
            closeAll: false
          });
    }

    toggleAll = () => {
        this.setState({
            modal: false,
            innerSecond: false,
            innerFinal: false,
            closeAll: true
        });
    }

    handleEmailSelections = selectedItems => {
        this.setState({selectedEmails: selectedItems});
    }

    handleRiskLevel = risk => {
        this.setState({selectedRiskLevel: risk});
    }

    startAddingEmail = () => {
        this.setState({startAddingEmail: true})
    }

    handleTaskTitle = (rawEditorState) => {
        let plaintextEmail = convertFromRaw(rawEditorState).getPlainText()
        plaintextEmail = stripUnicodeFromString( plaintextEmail )
        // plaintextEmail = plaintextEmail.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
        this.setState({taskTitle: rawEditorState, taskTitlePlainContent: plaintextEmail});
    }

    handleTaskExplanation = (rawEditorState) => {
        let plaintextEmail = convertFromRaw(rawEditorState).getPlainText()
        plaintextEmail = stripUnicodeFromString( plaintextEmail )
        // plaintextEmail = plaintextEmail.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
        this.setState({taskExplanation: rawEditorState, taskExplanationPlainContent: plaintextEmail});
    }

    proceedToSaveTask = () => {
        let deadLineMoment = null;
        let notificationDateMoment = null;
        let ready = true;

        if(this.state.deadline === null) {
            NotificationManager.error("Tarkistuspisteestä puuttuu deadline", "Virhe", 2000);
            ready = false;
        } else {
            deadLineMoment = new Date(moment(this.state.deadline))
        }

        if(this.state.notificationDate === null) {
            NotificationManager.error("Tarkistuspisteestä puuttuu muistutuspäivämäärä", "Virhe", 2000);
            ready = false;
        } else {
            notificationDateMoment =  new Date(moment(this.state.notificationDate));
        }

        if(this.state.selectedEmails.length === 0) {
            NotificationManager.error("Tarkistuspisteestä puuttuu vastuuhenkilö", "Virhe", 2000);
            ready = false;
        }

        if(deadLineMoment !== null && notificationDateMoment !== null && ready) {
            let payload = {
                type: this.state.taskType,
                deadline:  deadLineMoment,
                notificationDate: notificationDateMoment,
                title: this.state.taskTitlePlainContent,
                riskValues:  this.state.selectedRiskLevel,
                responsible: this.state.selectedEmails,
                styledMemo: this.state.taskExplanation,
                plaintextMemo: this.state.taskExplanationPlainContent,
                target: {...this.props.chosenTarget},
                activeReports: this.props.activeIds,
                companyTarget: this.props.activeCompany._id
            }
            this.props.onTaskAdd(payload);
        }
    }

    checkFirstValues = () => {
        let ready = true;
        if(this.state.taskTitlePlainContent === "") {
            ready = false;
        }

        if(this.state.taskExplanationPlainContent === "") {
            ready = false;
        }

        if(this.state.deadline === null) {
            ready = false;
        }

        if(this.state.notificationDate === null) {
            ready = false;
        }

        return ready;
    }

    checkSecondValues = () => {
        let ready = true;

        if(this.state.selectedEmails.length === 0) {
            ready = false;
        }

        return ready;
    }

    render() {
        const firstModalReady = this.checkFirstValues();
        const secondModalReady = this.checkSecondValues();
        if(this.state.modal) {
            return (
                    <Modal isOpen={this.state.modal} toggle={this.toggle} centered size="lg">
                    <ModalHeader toggle={this.toggle} className="taskModal">
                        <div>
                            Luo uusi tarkistuspiste
                            <span className="modalPageNumber">1 / 3</span>
                        </div> 
                    </ModalHeader>
                    <ModalBody>
                        <h4>{this.props.chosenTarget.targetText}</h4>
                        <Row className="taskCreatorRow">
                            <Col xl="12">
                                <p>Otsikko</p>
                                <TextEditor editorId={"taskCreatorTitle"}
                                    content={this.state.taskTitle || ""}
                                    onTextChange={this.handleTaskTitle}
                                    plaintextEditor={true}
                                    additionalClass="taskTitle"
                                />
                            </Col>
                            <Col xl="12">
                                <p>Selite</p>
                                    <TextEditor editorId={"taskCreatorExplanation"}
                                    content={this.state.taskExplanation}
                                    onTextChange={this.handleTaskExplanation}
                                    plaintextEditor={true}
                                    additionalClass="taskExplanation"
                                    styleEditor={true} 
                                    allowFileUpload={false}
                                />
                            </Col>
                            <Col xl="6">
                                <p>Muistutuspäivä</p>
                                <SingleDatePicker
                                    block
                                    date={this.state.notificationDate}
                                    onDateChange={date => this.setState({notificationDate:  date })}
                                    focused={this.state.focusedNotification} // PropTypes.bool
                                    onFocusChange={({ focused }) => this.setState({ focusedNotification: focused })} // PropTypes.func.isRequired
                                    id="notificationDate"
                                    openDirection={"up"} 
                                    numberOfMonths={1}
                                    hideKeyboardShortcutsPanel
                                    readOnly
                                />
                            </Col>  
                            <Col xl="6">
                                <p>Deadline</p>
                                    <SingleDatePicker
                                        block
                                        date={this.state.deadline}
                                        onDateChange={date => this.setState({deadline:  date })}
                                        focused={this.state.focusedDeadline} // PropTypes.bool
                                        onFocusChange={({ focused }) => this.setState({ focusedDeadline: focused })} // PropTypes.func.isRequired
                                        id="deadline"
                                        openDirection="up"
                                        numberOfMonths={1}
                                        hideKeyboardShortcutsPanel
                                        readOnly
                                    />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="taskCreatorFooter">
                        <a className="go-back-link" style={{marginLeft: 0, marginRight: 'auto'}} onClick={() => this.toggle()}>Peruuta</a>
                        {firstModalReady && <button className="small-white-button wide-button" onClick={() => this.toggleSecond()}>Jatka</button>}
                    </ModalFooter>
                </Modal>
            )
        }

        if(this.state.innerSecond) {
            return (
                <InnerSecondModal 
                        {...this.state}
                        messages={customEmailMessages.messages}
                        toggleSecond={this.toggleSecond}
                        toggleFinal={this.toggleFinal}
                        handleEmailSelections={this.handleEmailSelections}
                        handleRiskLevel={this.handleRiskLevel}
                        startAdding={this.startAddingEmail}
                        handleEmailChange={this.handleEmailChange}
                        handleEmailAdd={this.handleEmailAdd}
                        toggleAll={this.toggleAll}
                        modalReady={secondModalReady}
                    />
            )
        }

        if(this.state.innerFinal) {
            return (
                <InnerFinalModal 
                {
                    ...this.state
                }
                toggleFinal={this.toggleFinal}
                toggleAll={this.toggleAll}
                saveTask={this.proceedToSaveTask}
                fetchStatus={this.props.fetchStatus}
                />
            )
        }

        return (
            null
        )
    }
}

const mapStateToProps = state => {
    return {
        targetCompany: state.collaborations.targetCompany,
        fetchStatus: state.reports.taskModifyStatus,
        fetchMessage: state.reports.taskModifyMessage
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onModalOpen: (params) => dispatch(ActionCreator.fetchCompanyInformation(params)),
        onTaskAdd: (params) => dispatch(ActionCreator.addTask(params))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskCreatorModal);